import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Translation } from '@core/locales';
import { Box, factory, Prompt, Stack, Text } from '@coveord/plasma-mantine';
import { Children, isValidElement, useMemo } from 'react';
import { Locales } from '../../../strings/Locales.js';
import { ProjectsList } from '../ProjectsList.js';
import classes from './EditConfirmationPrompt.module.css';
import { EditConfirmationPromptCancelButton } from './EditConfirmationPromptCancelButton.js';
import { EditConfirmationPromptConfirmButton } from './EditConfirmationPromptConfirmButton.js';
export var EditConfirmationPrompt = factory(function(props, ref) {
    var _projects_data;
    var onClose = props.onClose, opened = props.opened, resourceName = props.resourceName, resourceType = props.resourceType, projects = props.projects, additionalDescription = props.additionalDescription, children = props.children, promptProps = _object_without_properties(props, [
        "onClose",
        "opened",
        "resourceName",
        "resourceType",
        "projects",
        "additionalDescription",
        "children"
    ]);
    var descriptionKey = projects.isError || ((_projects_data = projects.data) === null || _projects_data === void 0 ? void 0 : _projects_data.length) === 0 ? 'EditConfirmationPrompt.description.error' : 'EditConfirmationPrompt.description';
    var promptButtons = useMemo(function() {
        return Children.toArray(children).filter(function(child) {
            return /*#__PURE__*/ isValidElement(child) && (child.type === EditConfirmationPromptCancelButton || child.type === EditConfirmationPromptConfirmButton);
        });
    }, [
        children
    ]);
    return /*#__PURE__*/ _jsxs(Prompt, _object_spread_props(_object_spread({
        title: Locales.format('EditConfirmationPrompt.title', {
            resourceType: resourceType
        }),
        variant: "info",
        opened: opened,
        onClose: onClose,
        ref: ref
    }, promptProps), {
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                gap: "sm",
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        children: /*#__PURE__*/ _jsx(Translation, {
                            t: Locales,
                            i18nKey: descriptionKey,
                            options: {
                                resourceType: resourceType,
                                resourceName: resourceName
                            },
                            children: /*#__PURE__*/ _jsx(Text, {
                                inherit: true,
                                span: true,
                                fw: 500,
                                className: classes.root
                            })
                        })
                    }),
                    !projects.isError && /*#__PURE__*/ _jsx(ProjectsList, {
                        items: projects.data
                    }),
                    additionalDescription && /*#__PURE__*/ _jsx(Box, {
                        "data-testid": "edit-confirmation-prompt-additional-description",
                        children: additionalDescription
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Prompt.Footer, {
                children: promptButtons
            })
        ]
    }));
});
EditConfirmationPrompt.CancelButton = EditConfirmationPromptCancelButton;
EditConfirmationPrompt.ConfirmButton = EditConfirmationPromptConfirmButton;
EditConfirmationPrompt.displayName = 'EditConfirmationPrompt';

//# sourceMappingURL=EditConfirmationPrompt.js.map